import { Reveal } from "@/components/Reveal";
import { SectionHeader } from "@/components/SectionHeader";
import { ABOUT_SUMMARY, JOURNEY_STAGES } from "@/data/content";
import { ArrowRight, Cpu, Wrench, ShieldCheck } from "lucide-react";

const STAGE_ICONS = [Cpu, Wrench, ShieldCheck];

export const About = () => (
    <section id="about" data-testid="about-section" className="scroll-mt-20 py-24 md:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <SectionHeader chapter="01" kicker="About" title="About Me" testId="about-heading" />

            <Reveal>
                <p className="max-w-4xl border-l-2 border-neon/60 pl-6 text-base leading-relaxed text-zinc-300 md:text-lg">
                    {ABOUT_SUMMARY}
                </p>
            </Reveal>

            <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3">
                {JOURNEY_STAGES.map((stage, i) => {
                    const Icon = STAGE_ICONS[i];
                    return (
                        <Reveal key={stage.number} delay={i * 0.12}>
                            <article
                                data-testid={`about-stage-${stage.number}`}
                                className="group relative h-full border border-white/10 bg-surface/60 p-8 transition-[border-color,box-shadow] duration-500 hover:border-neon/40 hover:shadow-[0_0_28px_rgba(0,255,102,0.08)]"
                            >
                                <div className="mb-6 flex items-center justify-between">
                                    <span className="font-display text-5xl font-black tracking-tighter text-white/[0.07] transition-colors duration-500 group-hover:text-neon/20">
                                        {stage.number}
                                    </span>
                                    <Icon size={22} strokeWidth={1.5} className="text-neon/70" />
                                </div>
                                <h3 className="font-display text-xl font-bold tracking-tight text-zinc-100">
                                    {stage.title}
                                </h3>
                                <p className="mt-3 font-mono2 text-xs uppercase tracking-widest text-zinc-500">
                                    {stage.intro}
                                </p>
                                <ul className="mt-5 space-y-2.5">
                                    {stage.items.map((item) => (
                                        <li key={item} className="flex items-start gap-2.5 text-sm text-zinc-400">
                                            <span className="mt-1.5 h-1 w-1 shrink-0 bg-neon/70" />
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </article>
                        </Reveal>
                    );
                })}
            </div>

            <Reveal delay={0.2}>
                <div
                    data-testid="about-journey-strip"
                    className="mt-10 flex flex-wrap items-center gap-x-4 gap-y-3 border border-white/10 bg-white/[0.02] px-6 py-5 font-mono2 text-xs text-zinc-400 sm:text-sm"
                >
                    <span>Computer Engineering</span>
                    <ArrowRight size={14} className="text-neon" />
                    <span>Industrial Maintenance</span>
                    <ArrowRight size={14} className="text-neon" />
                    <span className="text-neon">Cybersecurity</span>
                </div>
            </Reveal>
        </div>
    </section>
);
